import React, { Component } from 'react'
import _ from 'lodash'
import { compose, graphql, withApollo } from 'react-apollo'
import { SelectInput, Form, Checkbox } from '../UI'
import { CATEGORIES } from '../../constants'
import { ALL_LANGUAGES } from '../../constants'
import SliderActivities from './SliderActivities'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { Typeahead } from 'react-bootstrap-typeahead'
import ALL_TAGS from '../../graphql/HomePage/AllTags.graphql'
import { observer } from 'mobx-react'
import searchStore from '../../mobx-store/search-store'

class GuidedActivities extends Component {
  constructor() {
    super()
    this.state = {
      filterActive: false,
      selectedCategorie: 'Any',
      selectedLanguage: 'All',
      selectedTags: [],
      filtered: false,
      isPrivate: false,
      isPrivateToFilter: false
    }
  }

  getAllLanguages = () => [{ value: 'All', label: 'All' }, ...ALL_LANGUAGES.map(item => ({ value: item['1'], label: item.name }))]

  getCategoriesOptions = () => {
    const options = []
    options.push({ label: 'Any', value: 'Any' })
    for (let key in CATEGORIES) {
      options.push({ label: key, value: key })
    }
    return options
  }

  handleSubmit = values => {
    //arr1.reduce((acc, r)=> arr2.includes(r)?acc:false, true)
    this.setState({
      selectedCategorie: values.categories,
      selectedLanguage: values.languages,
      selectedTags: this.typehead.instanceRef.state.selected,
      filterActive: false,
      filtered: true,
      isPrivate: values.private,
      isPrivateToFilter: this.state.isPrivate
    })
  }

  handlePrivateChange = e => {
    this.setState({
      isPrivate: !this.state.isPrivate
    })
  }

  render() {
    const { localTours, featuredDestinations, AllTags } = this.props

    console.log('searchStore', searchStore)
    return (
      <div className="main-container">
        <div className="filter-section">
          {/*extract later in separate filter component*/}
          <div className="filter-component">
            <button
              className={this.state.filterActive ? 'active filter-btn' : 'filter-btn'}
              onClick={() => this.setState({ filterActive: !this.state.filterActive })}
            >
              Filter
            </button>

            {this.state.filterActive && (
              <Form
                onSubmit={this.handleSubmit}
                submitBtnClassname="btn btn-lg btn-primary btn-danger"
                submitBtnName={'Apply'}
                className="filter-content"
              >
                <fieldset id="tags">
                  <label htmlFor="tags" className="margin-bottom-0-5">
                    Tags
                  </label>
                  <Typeahead
                    bsSize="small"
                    className="large-input"
                    labelKey="Tags"
                    ref={typehead => (this.typehead = typehead)}
                    clearButton
                    multiple={true}
                    options={_.uniqBy(_.get(AllTags, 'allTags', []).map(item => item.value), e => e)}
                    placeholder="Type tags..."
                  />
                </fieldset>
                <SelectInput
                  id="categories"
                  initialValue={'Any'}
                  options={this.getCategoriesOptions()}
                  label={'Categories'}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
                <SelectInput
                  id="languages"
                  initialValue={'All'}
                  options={this.getAllLanguages()}
                  label={'Languages'}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
                <Checkbox id="private" checked={this.state.isPrivate} handleChange={this.handlePrivateChange}>
                  Private Tours
                </Checkbox>
              </Form>
            )}
            {/*</div>*/}
          </div>
        </div>
        {!searchStore.pickedPlace.country &&
          !searchStore.rangeDate.endDate &&
          !this.state.filtered && (
            <SliderActivities
              collection={featuredDestinations.contentpoi.slice(0, 10)}
              type={'destination'}
              title={'Featured Destinations'}
            />
          )}
        {/*<SliderActivities collection={recentlyBooked.allPaymentTransactions.slice(0, 10)} type={'booked'} title={'Just Booked'} />*/}
        {this.state.selectedCategorie === 'Any' ? (
          this.getCategoriesOptions().map((item, index) => (
            <SliderActivities
              key={index}
              collection={localTours.localTour
                .filter(
                  tour =>
                    tour.categories.includes(item.label) &&
                    tour.categories.length > 0 &&
                    (tour.languages.includes(this.state.selectedLanguage) || this.state.selectedLanguage === 'All') &&
                    this.state.selectedTags.reduce((acc, r) => (tour.tags.map(tag => tag.value).includes(r) ? acc : false), true) &&
                    (this.state.isPrivateToFilter ? tour.privateTourPrice > 0 : true)
                )
                .filter(
                  tour =>
                    (_.get(tour, 'tourLocation.country', '') === searchStore.pickedPlace.country || !searchStore.pickedPlace.country) &&
                    (_.get(tour, 'tourLocation.city', '') === searchStore.pickedPlace.city || !searchStore.pickedPlace.city)
                )
                .slice(0, 10)}
              type={'tour'}
              title={item.label}
            />
          ))
        ) : (
          <SliderActivities
            collection={localTours.localTour
              .filter(
                tour =>
                  tour.categories.includes(this.state.selectedCategorie) &&
                  tour.categories.length > 0 &&
                  (tour.languages.includes(this.state.selectedLanguage) || this.state.selectedLanguage === 'All') &&
                  this.state.selectedTags.reduce((acc, r) => (tour.tags.map(tag => tag.value).includes(r) ? acc : false), true) &&
                  (this.state.isPrivateToFilter ? tour.privateTourPrice > 0 : true)
              )
              .filter(
                tour =>
                  (_.get(tour, 'tourLocation.country', '') === searchStore.pickedPlace.country || !searchStore.pickedPlace.country) &&
                  (_.get(tour, 'tourLocation.city', '') === searchStore.pickedPlace.city || !searchStore.pickedPlace.city)
              )
              .slice(0, 10)}
            type={'tour'}
            title={this.state.selectedCategorie}
          />
        )}
      </div>
    )
  }
}

export default compose(graphql(ALL_TAGS, { name: 'AllTags' }))(withApollo(observer(GuidedActivities)))



// WEBPACK FOOTER //
// src/components/homepage/GuidedActivitiesComponent.js